import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIconUrl } from './icon-url.interface';

@Component({
  selector: 'app-icon-url',
  templateUrl: 'icon-url.component.html',
  styleUrls: ['icon-url.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconUrlComponent {
  @Input() icon: IIconUrl;
}
